import { ITask } from '../../TInvoker';

export default function collectAll(tasks: ReadonlyArray<ITask>): any[] {
    return tasks
        .map((item) => item.result);
}
